<template>
    <svg xmlns="http://www.w3.org/2000/svg"
         :width="size"
         :height="size"
         viewBox="0 0 24 24"
         fill="none"
         :stroke="color"
         stroke-width="2"
         stroke-linecap="round"
         stroke-linejoin="round">
        <path d="M2.5 2v6h6M21.5 22v-6h-6"/><path d="M22 11.5A10 10 0 0 0 3.2 7.2M2 12.5a10 10 0 0 0 18.8 4.2">
            <animateTransform attributeType="xml"
                              attributeName="transform"
                              type="rotate"
                              from="0 20 20"
                              to="360 20 20"
                              dur="0.8s"
                              repeatCount="indefinite"/>
        </path>
    </svg>
</template>
<script>
    export default {
        props: {
            size: { type: [String, Number], default: 22 },
            color: { type: String, default: 'white' }
        }
    }
</script>
